import environment from '~/platform/utilities/environment';

export const SUBMIT_URL = `${
  environment.API_URL
}/v0/education_benefits_claims/10278`;

export const TITLE =
  'Authorize VA to disclose personal information to a third party for education benefits';
export const SUBTITLE =
  'Authorization to disclose personal information to a third party (VA Form 22-10278)';
